import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';

import Avatar from '@material-ui/core/Avatar';
import AccountCircle from '@material-ui/icons/AccountCircle';

import { BlueRightArrowIcon } from '../../../../images/icons/WrapSvg';

function getSurnameFormat(name) {
    return name ? titleCase(name.replace(',', '')).trim() : '';
}

function titleCase(str) {
    return str
        .toLowerCase()
        .split(' ')
        .map(function(word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(' ');
}

class User extends React.Component {
    handleClick = (event) => {
        this.props.history.push('/manage/user/' + this.props.user.login);
    };

    render() {
        const { user, active, last } = this.props;
        const nombre = user.nombre.toUpperCase().trim() + ' ' + getSurnameFormat(user.apellidos);
        return (
            <div
                className={
                    'flex_full_row padding_top_24 padding_left_12 margin_left_24 c_grey_blue hand ' +
                    (active ? 'active' : '')
                }
                onClick={this.handleClick}
            >
                <Avatar className={'avatar margin_right_12'}>
                    {user && user.foto && (
                        <img
                            src={user.foto}
                            alt="Preview"
                            style={{ width: 40 }}
                            onClick={this.openAvatarDialog}
                        />
                    )}
                    {(!user || !user.foto) && (
                        <AccountCircle
                            className={'bg_bluish'}
                            style={{ fontSize: 40 }}
                            onClick={this.openAvatarDialog}
                        />
                    )}
                </Avatar>
                <div
                    className={classNames(
                        'flex_full_row align_center',
                        last ? 'noshadow' : 'shadow_down',
                    )}
                >
                    <div className={'flex_full_row '}>
                        <span className="barlow_medium c_dark_grey_blue">{nombre}</span>
                    </div>
                    <BlueRightArrowIcon color="primary" />
                </div>
            </div>
        );
    }
}

User.propTypes = {
    history: PropTypes.object.isRequired,
};

User = withRouter(User);

export default User;



// WEBPACK FOOTER //
// ./src/components/complex/manage/users/User.js